import { ReactElement, useContext, useEffect, useState } from 'react'
import UserAction from '../../../context/action/UserAction'
import { UserContext } from '../../../context/UserContext'
import DevelopusInputTextarea from '../../../../../common/ui/input/DevelopusInputTextarea'
import { t } from 'i18next'
import DevelopusInputNumber from '../../../../../common/ui/input/DevelopusInputNumber'

const CreatePayment = (): ReactElement => {
  const context = useContext(UserContext)
  const action = new UserAction(context)

  const [paid, setPaid] = useState<number>(0.0)
  const [description, setDescription] = useState<string>('')

  useEffect(() => {
    action.setCreatePayment(paid, description)
  }, [paid, description])

  return (
    <div style={{ width: '90vw' }}>
      <DevelopusInputTextarea
        defaultValue={description}
        onChange={setDescription}
        label={t('users.transactions.description')}
      />
      <DevelopusInputNumber
        value={paid}
        placeholder={t('users.transactions.paid')}
        label={t('users.transactions.paid')}
        onChange={setPaid}
      />
    </div>
  )
}

export default CreatePayment
